'use strict';

const TaskBuilder = require('../../models/task-builder'),
	mmWidgets = require('../../widgets/mm-widgets');

require('../../widgets/subscription-purchase-widget');
require('../../widgets/change-card-widget');
require('../../widgets/registration-details-widget');
require('../../widgets/terms-and-conditions-widget');
require('../../widgets/personal-signup-widget');
require('../../widgets/gold-plan-selector-widget');
require('../../widgets/account-info-value-toggle-widget');
require('../../widgets/account-info-value-widget');
require('../../widgets/user-profile-widget');
require('../../widgets/gold-currency-selector-widget');
require('../../widgets/plan-upgrade-widget');

module.exports = function personalSignupStart(config, subscriptionModel, subscriptionPlanModel, authenticationModel, navigatorShim, s3Api, goldApi, context) {
	const taskBuilder = new TaskBuilder(goldApi, s3Api, navigatorShim, authenticationModel.getLicense),
		registrationSection = context ? `${context}-register` : 'register';


	mmWidgets('[data-mm-role~="subscriptionPurchase"]').subscriptionPurchaseWidget({ subscriptionModel, subscriptionPlanModel, navigatorShim, taskBuilder});
	mmWidgets('[data-mm-role~="changeCard"]').changeCardWidget(subscriptionModel, navigatorShim, taskBuilder);

	mmWidgets('[data-mm-role~="personalAccountSignup"]')
		.registrationDetailsWidget(registrationSection, subscriptionModel, navigatorShim)
		.personalSignupWidget(authenticationModel, subscriptionModel, subscriptionPlanModel, context)
		.termsAndConditionsWidget(subscriptionModel);
	mmWidgets('[data-mm-role~="plan-selector"]').goldPlanSelectorWidget(subscriptionPlanModel);
	mmWidgets('[data-mm-role~="currency-selector"]').goldCurrencySelectorWidget(subscriptionPlanModel);
	mmWidgets('[data-mm-account-info-toggle]').accountInfoValueToggleWidget(subscriptionModel, authenticationModel);
	mmWidgets('[data-mm-subscription-value]').accountInfoValueWidget(subscriptionModel);
	mmWidgets('[data-mm-user-profile]').userProfileWidget(authenticationModel);
	mmWidgets('[data-mm-role~="changeToYearlyPlan"]').planUpgradeWidget(subscriptionPlanModel, subscriptionModel, taskBuilder);
	mmWidgets('[data-mm-role~="changeToTeamPlan"]').planUpgradeWidget(subscriptionPlanModel, subscriptionModel, taskBuilder);

};
